module.exports = __webpack_public_path__ + "e5b98877828162c928a03df0d789c555.png";